/* Compartilhar: copiar link, menu nativo do celular e janela do fim da matéria.
   Os links das redes (partials/compartilhar.hbs) funcionam sem este script. */
(function () {
    var copyButtons = document.querySelectorAll('[data-share-copy]');
    var nativeButtons = document.querySelectorAll('[data-share-native]');
    var dialog = document.querySelector('[data-share-dialog]');
    if (!copyButtons.length && !nativeButtons.length && !dialog) return;

    // Copiar link: mostra "Link copiado!" por 2 segundos no próprio botão
    function copyText(text) {
        // API moderna primeiro; se não existir ou for recusada, usa o método antigo
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text).catch(function () {
                return copyWithSelection(text);
            });
        }
        return copyWithSelection(text);
    }

    function copyWithSelection(text) {
        return new Promise(function (resolve, reject) {
            var input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            var ok = document.execCommand('copy');
            document.body.removeChild(input);
            ok ? resolve() : reject(new Error('copy failed'));
        });
    }

    copyButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var label = button.querySelector('.share-btn-label');
            var original = label ? label.textContent : '';
            copyText(button.getAttribute('data-share-copy')).then(function () {
                button.classList.add('is-copied');
                button.setAttribute('aria-label', 'Link copiado!');
                if (label) label.textContent = 'Link copiado!';
                setTimeout(function () {
                    button.classList.remove('is-copied');
                    button.setAttribute('aria-label', 'Copiar link');
                    if (label) label.textContent = original;
                }, 2000);
            });
        });
    });

    // Menu nativo (Instagram, Messenger, SMS…): só em celular/tablet com suporte
    var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (navigator.share && isTouch) {
        var title = document.title;
        var excerptEl = document.querySelector('.article-excerpt');
        var url = (document.querySelector('link[rel="canonical"]') || {}).href || location.href;
        nativeButtons.forEach(function (button) {
            button.hidden = false;
            button.addEventListener('click', function () {
                navigator.share({
                    title: title,
                    text: excerptEl ? excerptEl.textContent.trim() : title,
                    url: url
                }).catch(function () {}); // usuário cancelou
            });
        });
    }

    // Janela com todas as redes (fim da matéria)
    if (dialog && typeof dialog.showModal === 'function') {
        document.querySelectorAll('[data-share-open]').forEach(function (button) {
            button.addEventListener('click', function () {
                dialog.showModal();
            });
        });
        dialog.querySelectorAll('[data-share-close]').forEach(function (button) {
            button.addEventListener('click', function () {
                dialog.close();
            });
        });
        // clicar fora da caixa (no fundo escurecido) fecha
        dialog.addEventListener('click', function (event) {
            if (event.target === dialog) dialog.close();
        });
        // escolher uma rede fecha a janela
        dialog.querySelectorAll('a.share-btn').forEach(function (link) {
            link.addEventListener('click', function () {
                dialog.close();
            });
        });
    }
})();
